export const WINDOW_WIDTH = 550;
export const WINDOW_HEIGHT = 450;
